import { TournamentsApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useTournamentsAPI(): TournamentsApi {
  return new TournamentsApi(apiConfig);
}
